var link_preview_default = {
  "fontElementMap": "CYZTF",
  "linkPreviewContainer": "LzN7W",
  "linkPreview": "_7ftJT",
  "linkPreviewImage": "_2ukT5",
  "linkPreviewInfo": "-RpGI",
  "linkPreviewTitle": "vXJ--",
  "linkPreviewDescription": "_8C0NH",
  "linkPreviewUrl": "JLIb3"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
